import { faCopy } from "@fortawesome/sharp-regular-svg-icons";
import { faCopy as fasCopy } from "@fortawesome/sharp-solid-svg-icons";
import { buildMarkdownFooter } from "../functions/markdown.jsx";
import { Button } from "eone-ui/buttons/button";
import { useState } from "react";

export function HelpCopy(props) {
    const { ProductName, CopyState, ContainerRef } = props;

    const { Markdown, Slug, ItemHelpSiteUrl } = CopyState ?? {};

    const [copied, setCopied] = useState(false);

    const getButtonMenuItems = () => {
        const menuItems = [{
            Label: "Copy page as HTML",
            OnClick: copyHtml
        }];

        if (ItemHelpSiteUrl) {
            menuItems.push({
                Label: "View page as markdown",
                OnClick: viewMarkdown
            });

            menuItems.push({
                Label: "Open in ChatGPT",
                OnClick: () => openInAssistant((prompt) => `https://chatgpt.com/?hints=search&q=${encodeURIComponent(prompt)}`)
            });

            menuItems.push({
                Label: "Open in Claude",
                OnClick: () => openInAssistant((prompt) => `https://claude.ai/new?q=${encodeURIComponent(prompt)}`)
            });
        }

        if (Markdown) {
            menuItems.push({
                Label: "Copy page as markdown",
                OnClick: copyMarkdown
            });

            if (Slug) {
                menuItems.push({
                    Label: "Download as markdown",
                    OnClick: downloadMarkdown
                });
            }
        }

        return menuItems;
    };

    const openInAssistant = (buildUrl) => {
        const prompt = `Read ${ItemHelpSiteUrl} so I can ask questions about this ${ProductName} documentation page.`;
        window.open(buildUrl(prompt), "_blank", "noopener");
    };

    const handleSetCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
    };

    const viewMarkdown = () => {
        window.open(ItemHelpSiteUrl, "_blank", "noopener");
    };

    const copyMarkdown = async () => {
        await navigator.clipboard.writeText(Markdown);
        handleSetCopy();
    };

    const downloadMarkdown = () => {
        const footer = ItemHelpSiteUrl ? buildMarkdownFooter(`${ProductName} documentation`, ItemHelpSiteUrl) : "";
        const blob = new Blob([Markdown + footer], { type: "text/markdown" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = Slug + ".md";
        link.click();
        URL.revokeObjectURL(url);
    };

    const copyHtml = async () => {
        const body = ContainerRef?.current;
        const content = body.innerHTML;
        const htmlBlob = new Blob([content], { type: "text/html" });
        const clipboardItem = new ClipboardItem({
            "text/html": htmlBlob
        });
        await navigator.clipboard.write([clipboardItem]);
        handleSetCopy();
    };

    const menuItems = getButtonMenuItems();
    if (menuItems.length === 0) return null;

    return (
        <Button
            ContainerClass="pd-documentation-page-copy-button"
            MenuItems={menuItems}
            Label={copied ? "Copied" : "Copy"}
            Icon={copied ? fasCopy : faCopy} />
    );
}